













import { Component, Vue } from "vue-property-decorator";
import { openId } from "@/config";
import { setId, setRouteName } from "@/config/cookies";
import { getUserStatus, setUserYigouAccount } from "@/api/users";
import { getUrlParam, isWxClient } from "@/config/utils";
import _ from "lodash";
@Component
export default class extends Vue {
  private provide() {
    return {
      reload: this.reload,
    };
  }
  private iswx: boolean = true;
  private isRouterAlive: boolean = false;
  private reload() {
    this.isRouterAlive = false;
    this.$nextTick(function() {
      this.isRouterAlive = true;
    });
  }
  private code: string = "";
  private getWxCode() {
    const appid = openId;
    const code = getUrlParam("code");
    const local = window.location.href;
    if (code == null || code === "") {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
        local
      )}&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect`;
    } else {
      this.code = code;
      this.getUserInfo();
    }
  }

  private mounted() {
    setRouteName("");
    if (!isWxClient()) {
      this.iswx = false;
      return;
    }
    this.getWxCode();
  }

  private async getUserInfo() {
    const res: any = await getUserStatus({ code: this.code });
    let that = this;
    if (res.status) {
      setId(res.openId);
      this.isRouterAlive = true;
      if (res.status == "1") {
      } else if (res.status == "2") {
        this.$dialog
          .confirm({
            title: "授权登录",
            message: res.info,
          })
          .then(async () => {
            const data = _.pick(res, ["openId", "nickName", "headImgUrl"]);
            const result: any = await setUserYigouAccount(data);
            if (result.status) {
              that.$toast.success("登陆成功");
              // that.$router.replace({ name: "BandCar" });
            } else {
              that.$notify(result.info);
            }
          })
          .catch(() => {
            // @ts-ignore
            WeixinJSBridge.invoke("closeWindow", {}, function(res: any) {});
          });
      }
    } else {
      this.$notify(res.info);
    }
  }
}
